<template>
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
          d="M8 15.5C12.1421 15.5 15.5 12.1421 15.5 8C15.5 3.85786 12.1421 0.5 8 0.5C3.85786 0.5 0.5 3.85786 0.5 8C0.5 12.1421 3.85786 15.5 8 15.5Z"
          fill="#C6C6C6"
        />
        <path
          d="M7.502 10.304C7.25933 10.304 7.082 10.276 6.97 10.22C6.86733 10.1547 6.816 10.0473 6.816 9.898C6.816 9.48733
            6.914 9.114 7.11 8.778C7.306 8.43267 7.52533 8.11533 7.768 7.826C8.06667 7.48067 8.342 7.17267 8.594 6.902C8.85533
            6.622 8.986 6.36533 8.986 6.132C8.986 5.88933 8.902 5.698 8.734 5.558C8.566 5.418 8.30467 5.348 7.95 5.348C7.67933
            5.348 7.43667 5.38533 7.222 5.46C7.01667 5.52533 6.83933 5.59533 6.69 5.67C6.55 5.74467 6.44733 5.782 6.382 5.782C6.25133
            5.782 6.116 5.70733 5.976 5.558C5.84533 5.40867 5.73333 5.24067 5.64 5.054C5.54667 4.86733 5.5 4.72733 5.5 4.634C5.5 4.42867
            5.584 4.256 5.752 4.116C5.92 3.96667 6.13467 3.85 6.396 3.766C6.66667 3.67267 6.956 3.60733 7.264 3.57C7.572 3.52333 7.86133
            3.5 8.132 3.5C8.75733 3.5 9.294 3.60267 9.742 3.808C10.1993 4.004 10.5493 4.28867 10.792 4.662C11.044 5.03533 11.17 5.47867
            11.17 5.992C11.17 6.36533 11.1047 6.69667 10.974 6.986C10.8433 7.266 10.6753 7.51333 10.47 7.728C10.274 7.94267 10.0687
            8.148 9.854 8.344C9.56467 8.60533 9.294 8.85733 9.042 9.1C8.79 9.33333 8.63133 9.60867 8.566 9.926C8.538 10.0753 8.46333
            10.178 8.342 10.234C8.23 10.2807 8.05733 10.304 7.824 10.304H7.502ZM7.432 13.44C6.872 13.44 6.592 13.2907 6.592 12.992V11.704C6.592
            11.4053 6.872 11.256 7.432 11.256H7.88C8.44 11.256 8.72 11.4053 8.72 11.704V12.992C8.72 13.2907 8.44 13.44 7.88 13.44H7.432Z"
          fill="white"
        />
      </svg>
</template>

<script>
export default {
  name: 'IconQuestion',
};
</script>
